import { useContext } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { useGetEnquiryKeeperDetails } from 'Utilities/vehicles/hooks/useGetEnquiryKeeperDetails';

import PageLoader from 'Components/transitions/PageLoader/PageLoader';

import { FAMILY_KEY } from '../../../../../vehicleProfiling/VehicleProfiling.constants';
import { DocumentCaptureOfferContext } from '../../../../DocumentCaptureContexts';
import { IncodeAuthorisationLink } from '../components/IncodeAuthorisationLink/IncodeAuthorisationLink';
import { IncodeFooter } from '../components/IncodeFooter';
import { KeeperAttentionInfoBox } from '../components/KeeperAttentionInfoBox/KeeperAttentionInfoBox';
import { INCODE_PROGRESS_STATUS, INCODE_PROGRESS_STEP, INCODE_ROUTES, IncodeStepProps } from '../IncodeSDKHelpers';
import { usePostIncodeProgress } from '../progress/incodeProgress';

import LocalTexts from './Incode.texts.json';

import styles from './IncodeShareAuthorisationLink.module.scss';

const LocalT = new MDText(LocalTexts.shareAuthorisationLink);

export const IncodeShareAuthorisationLinkStart = ({
  DP_ENQUIRY_ID,
  incodeSession,
}: IncodeStepProps) => {
  const { IncodeProgressLoading, postIncodeComplete } = usePostIncodeProgress();

  const { data } = useContext(DocumentCaptureOfferContext) || {};
  const hasOfferContext = Boolean(data?.seller);

  const {
    isLoading: isKeeperLoading,
    keeperName: fetchedKeeperName,
    keeperType: fetchedKeeperType,
  } = useGetEnquiryKeeperDetails(hasOfferContext ? undefined : DP_ENQUIRY_ID);

  if (isKeeperLoading) {
    return <PageLoader />;
  }

  const keeperName = data?.seller?.keeperName ?? fetchedKeeperName;
  const keeperType = data?.seller?.keeperType ?? fetchedKeeperType;
  const isFamilyOrFriendKeeper = keeperType === FAMILY_KEY;

  return (
    <>
      <IncodeProgressLoading />
      <div className={styles.component}>
        <IncodeAuthorisationLink
          headingElement="h1"
          keeperName={keeperName}
          saleVerificationId={incodeSession?.saleVerificationId}
        />
        {isFamilyOrFriendKeeper && <KeeperAttentionInfoBox />}
        <IncodeFooter>
          <Button
            fullWidth
            label={LocalT.translate('cta')}
            onClick={() => postIncodeComplete({
              fallbackNextStep: INCODE_ROUTES.CAPTURE_LICENSE,
              incodeSession,
              status: INCODE_PROGRESS_STATUS.SUCCESS,
              step: INCODE_PROGRESS_STEP.KEEPER_AUTHORIZATION,
            })}
          />
        </IncodeFooter>
      </div>
    </>
  );
};
